import { createFileRoute, redirect } from '@tanstack/react-router'

// This address used to show a mock checkout that asked for a card and took no payment.
// The real one is Stripe's embedded form, opened from the Billing tab in Settings.
export const Route = createFileRoute('/_authenticated/billing/checkout')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { tab: 'billing' } as never })
  },
})
